import { createGlobalStyle } from 'styled-components';
import {
  AA_TEXT_ON_LIGHT,
  AA_TEXT_PRIMARY_ON_LIGHT,
  AA_LINK_ON_LIGHT,
  AA_LINK_HOVER_ON_LIGHT,
  AA_DISABLED_TEXT,
  AA_DISABLED_BG,
  AA_DISABLED_BORDER,
  AA_TAG_SUCCESS_TEXT,
  AA_TAG_SUCCESS_BG,
  AA_TAG_SUCCESS_BORDER,
  AA_TAG_ERROR_TEXT,
  AA_TAG_ERROR_BG,
  AA_TAG_ERROR_BORDER,
} from '~/modules/Helper/contrast.helper';

const highContrastColors = {
  background: 'black',
  color: 'yellow',
};

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Segoe UI' !important;

    ::placeholder {
      color: ${props =>
        props.theme.highContrast
          ? highContrastColors.color
          : AA_TEXT_ON_LIGHT} !important;
    }

    ::selection {
      background-color: ${props =>
        props.theme.highContrast && highContrastColors.color} !important;
    }

    background-color: ${props =>
      props.theme.highContrast && highContrastColors.background} !important;

    border-color: ${props =>
      props.theme.highContrast && highContrastColors.color} !important;

    color: ${props =>
      props.theme.highContrast && highContrastColors.color} !important;
  }

  /* WCAG — contraste AA residual (texto/links em fundo claro) */
  ${props =>
    !props.theme.highContrast
      ? `
  .ant-layout-content {
    color: ${AA_TEXT_PRIMARY_ON_LIGHT};
  }

  .ant-menu-dark .ant-menu-item,
  .ant-menu-dark .ant-menu-item > a,
  .ant-menu-dark .ant-menu-submenu-title,
  .ant-menu-dark .ant-menu-item .ant-menu-title-content,
  .ant-menu-dark .ant-menu-submenu-title .ant-menu-title-content {
    color: #ffffff !important;
  }

  .ant-typography-secondary,
  .ant-form-item-extra,
  .ant-form-item-explain,
  .ant-empty-description,
  .ant-table-placeholder,
  .ant-table-placeholder .ant-empty-description,
  .ant-select-selection-placeholder,
  .ant-pagination-total-text,
  .ant-breadcrumb-separator {
    color: ${AA_TEXT_ON_LIGHT} !important;
  }

  a.ant-typography,
  .ant-typography a,
  .ant-btn-link,
  .ant-breadcrumb a,
  .ant-breadcrumb-link a,
  .ant-pagination-item a,
  .ant-layout-content a:not(.ant-btn):not([class*="social"]) {
    color: ${AA_LINK_ON_LIGHT};
  }

  a.ant-typography:hover,
  .ant-typography a:hover,
  .ant-btn-link:hover,
  .ant-btn-link:focus,
  .ant-breadcrumb a:hover,
  .ant-pagination-item a:hover,
  .ant-layout-content a:not(.ant-btn):not([class*="social"]):hover {
    color: ${AA_LINK_HOVER_ON_LIGHT};
  }

  .ant-pagination-item-active a {
    color: ${AA_LINK_HOVER_ON_LIGHT};
  }

  .leaflet-popup-content,
  .leaflet-popup-content a {
    color: ${AA_LINK_ON_LIGHT};
  }

  .leaflet-container a.leaflet-popup-close-button {
    color: ${AA_TEXT_PRIMARY_ON_LIGHT};
  }

  .ant-tag-success {
    color: ${AA_TAG_SUCCESS_TEXT} !important;
    background: ${AA_TAG_SUCCESS_BG} !important;
    border-color: ${AA_TAG_SUCCESS_BORDER} !important;
  }

  .ant-tag-error {
    color: ${AA_TAG_ERROR_TEXT} !important;
    background: ${AA_TAG_ERROR_BG} !important;
    border-color: ${AA_TAG_ERROR_BORDER} !important;
  }

  .ant-btn-primary[disabled],
  .ant-btn-primary[disabled]:hover,
  .ant-btn-primary[disabled]:focus,
  .ant-btn-primary[disabled]:active {
    color: ${AA_DISABLED_TEXT} !important;
    background: ${AA_DISABLED_BG} !important;
    border-color: ${AA_DISABLED_BORDER} !important;
    text-shadow: none !important;
    opacity: 1 !important;
  }
  `
      : ''}
  
  .ant-table-footer{
    padding: 14px 14px;
  }

  .ant-btn:not(.ant-btn-circle):not(.ant-btn-round) {
    border-radius: 8px;
  }

  .ant-btn,
  .ant-pagination .ant-pagination-item,
  .ant-pagination .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination .ant-pagination-next .ant-pagination-item-link,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-width: 1px !important;
    background-clip: padding-box;
  }

  .ant-btn.ant-btn-circle {
    border-radius: 50% !important;
  }

  .ant-btn.ant-btn-round {
    border-radius: 999px !important;
  }

  .ant-pagination .ant-pagination-item,
  .ant-pagination .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination .ant-pagination-next .ant-pagination-item-link {
    border-radius: 8px;
  }

  .ant-pagination .ant-pagination-item {
    overflow: hidden;
  }

  .ant-pagination .ant-pagination-item-active a {
    font-weight: 620;
  }

  .ant-pagination-options .ant-select-selector,
  .ant-pagination-options-size-changer .ant-select-selector {
    border-radius: 8px;
  }

  .ant-pagination ~ .ant-select .ant-select-selector {
    border-radius: 8px;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 8px !important;
    overflow: hidden;
  }

  &&.access-button{
    width: 23.5% !important
  }

  .maxHeight500 {
    max-height: 500px;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.5);
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.5) transparent;
  }

`;

export default GlobalStyle;
